// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UseCasesRouteImport } from './routes/use-cases'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ScriptsRouteImport } from './routes/scripts'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PackRouteImport } from './routes/pack'
import { Route as MySymbolsRouteImport } from './routes/my-symbols'
import { Route as LennyFacesRouteImport } from './routes/lenny-faces'
import { Route as KaomojiRouteImport } from './routes/kaomoji'
import { Route as ExportRouteImport } from './routes/export'
import { Route as DrawRouteImport } from './routes/draw'
import { Route as DecorativeRouteImport } from './routes/decorative'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FontsIndexRouteImport } from './routes/fonts.index'
import { Route as FontGeneratorIndexRouteImport } from './routes/font-generator.index'
import { Route as SymbolSlugRouteImport } from './routes/symbol.$slug'
import { Route as IndexCodepointsRouteImport } from './routes/index.codepoints'
import { Route as IndexAZRouteImport } from './routes/index.a-z'
import { Route as FontsSlugRouteImport } from './routes/fonts.$slug'
import { Route as FontGeneratorSlugRouteImport } from './routes/font-generator.$slug'
import { Route as CollectionsSlugRouteImport } from './routes/collections.$slug'
import { Route as UseCasesIndexRouteImport } from './routes/use-cases.index'
import { Route as UseCasesSlugRouteImport } from './routes/use-cases.$slug'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsSlugRouteImport } from './routes/tools.$slug'
import { Route as ScriptsIndexRouteImport } from './routes/scripts.index'
import { Route as ScriptsSlugRouteImport } from './routes/scripts.$slug'
import { Route as PackIndexRouteImport } from './routes/pack.index'
import { Route as PackDataRouteImport } from './routes/pack.$data'
import { Route as KaomojiIndexRouteImport } from './routes/kaomoji.index'
import { Route as KaomojiSlugRouteImport } from './routes/kaomoji.$slug'
import { Route as DecorativeIndexRouteImport } from './routes/decorative.index'
import { Route as DecorativeSlugRouteImport } from './routes/decorative.$slug'
import { Route as CategoriesIndexRouteImport } from './routes/categories.index'
import { Route as CategoriesSlugRouteImport } from './routes/categories.$slug'
import { Route as IndexCodepointsIndexRouteImport } from './routes/index.codepoints.index'
import { Route as IndexCodepointsRangeRouteImport } from './routes/index.codepoints.$range'
import { Route as IndexAZIndexRouteImport } from './routes/index.a-z.index'
import { Route as IndexAZLetterRouteImport } from './routes/index.a-z.$letter'

const UseCasesRoute = UseCasesRouteImport.update({
            id: '/use-cases',path: '/use-cases',getParentRoute: () => rootRouteImport
          })
const ToolsRoute = ToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ScriptsRoute = ScriptsRouteImport.update({
            id: '/scripts',path: '/scripts',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PackRoute = PackRouteImport.update({
            id: '/pack',path: '/pack',getParentRoute: () => rootRouteImport
          })
const MySymbolsRoute = MySymbolsRouteImport.update({
            id: '/my-symbols',path: '/my-symbols',getParentRoute: () => rootRouteImport
          })
const LennyFacesRoute = LennyFacesRouteImport.update({
            id: '/lenny-faces',path: '/lenny-faces',getParentRoute: () => rootRouteImport
          })
const KaomojiRoute = KaomojiRouteImport.update({
            id: '/kaomoji',path: '/kaomoji',getParentRoute: () => rootRouteImport
          })
const ExportRoute = ExportRouteImport.update({
            id: '/export',path: '/export',getParentRoute: () => rootRouteImport
          })
const DrawRoute = DrawRouteImport.update({
            id: '/draw',path: '/draw',getParentRoute: () => rootRouteImport
          })
const DecorativeRoute = DecorativeRouteImport.update({
            id: '/decorative',path: '/decorative',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CategoriesRoute = CategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const FontsIndexRoute = FontsIndexRouteImport.update({
            id: '/fonts/',path: '/fonts/',getParentRoute: () => rootRouteImport
          })
const FontGeneratorIndexRoute = FontGeneratorIndexRouteImport.update({
            id: '/font-generator/',path: '/font-generator/',getParentRoute: () => rootRouteImport
          })
const SymbolSlugRoute = SymbolSlugRouteImport.update({
            id: '/symbol/$slug',path: '/symbol/$slug',getParentRoute: () => rootRouteImport
          })
const IndexCodepointsRoute = IndexCodepointsRouteImport.update({
            id: '/index/codepoints',path: '/index/codepoints',getParentRoute: () => rootRouteImport
          })
const IndexAZRoute = IndexAZRouteImport.update({
            id: '/index/a-z',path: '/index/a-z',getParentRoute: () => rootRouteImport
          })
const FontsSlugRoute = FontsSlugRouteImport.update({
            id: '/fonts/$slug',path: '/fonts/$slug',getParentRoute: () => rootRouteImport
          })
const FontGeneratorSlugRoute = FontGeneratorSlugRouteImport.update({
            id: '/font-generator/$slug',path: '/font-generator/$slug',getParentRoute: () => rootRouteImport
          })
const CollectionsSlugRoute = CollectionsSlugRouteImport.update({
            id: '/collections/$slug',path: '/collections/$slug',getParentRoute: () => rootRouteImport
          })
const UseCasesIndexRoute = UseCasesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UseCasesRoute
          })
const UseCasesSlugRoute = UseCasesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => UseCasesRoute
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ToolsRoute
          })
const ToolsSlugRoute = ToolsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ToolsRoute
          })
const ScriptsIndexRoute = ScriptsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ScriptsRoute
          })
const ScriptsSlugRoute = ScriptsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ScriptsRoute
          })
const PackIndexRoute = PackIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PackRoute
          })
const PackDataRoute = PackDataRouteImport.update({
            id: '/$data',path: '/$data',getParentRoute: () => PackRoute
          })
const KaomojiIndexRoute = KaomojiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => KaomojiRoute
          })
const KaomojiSlugRoute = KaomojiSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => KaomojiRoute
          })
const DecorativeIndexRoute = DecorativeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DecorativeRoute
          })
const DecorativeSlugRoute = DecorativeSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => DecorativeRoute
          })
const CategoriesIndexRoute = CategoriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CategoriesRoute
          })
const CategoriesSlugRoute = CategoriesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CategoriesRoute
          })
const IndexCodepointsIndexRoute = IndexCodepointsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => IndexCodepointsRoute
          })
const IndexCodepointsRangeRoute = IndexCodepointsRangeRouteImport.update({
            id: '/$range',path: '/$range',getParentRoute: () => IndexCodepointsRoute
          })
const IndexAZIndexRoute = IndexAZIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => IndexAZRoute
          })
const IndexAZLetterRoute = IndexAZLetterRouteImport.update({
            id: '/$letter',path: '/$letter',getParentRoute: () => IndexAZRoute
          })





const CategoriesRouteChildren = {
  CategoriesSlugRoute: CategoriesSlugRoute,CategoriesIndexRoute: CategoriesIndexRoute
}

const CategoriesRouteWithChildren = CategoriesRoute._addFileChildren(CategoriesRouteChildren)




const DecorativeRouteChildren = {
  DecorativeSlugRoute: DecorativeSlugRoute,DecorativeIndexRoute: DecorativeIndexRoute
}

const DecorativeRouteWithChildren = DecorativeRoute._addFileChildren(DecorativeRouteChildren)




const KaomojiRouteChildren = {
  KaomojiSlugRoute: KaomojiSlugRoute,KaomojiIndexRoute: KaomojiIndexRoute
}

const KaomojiRouteWithChildren = KaomojiRoute._addFileChildren(KaomojiRouteChildren)




const PackRouteChildren = {
  PackDataRoute: PackDataRoute,PackIndexRoute: PackIndexRoute
}

const PackRouteWithChildren = PackRoute._addFileChildren(PackRouteChildren)




const ScriptsRouteChildren = {
  ScriptsSlugRoute: ScriptsSlugRoute,ScriptsIndexRoute: ScriptsIndexRoute
}

const ScriptsRouteWithChildren = ScriptsRoute._addFileChildren(ScriptsRouteChildren)




const ToolsRouteChildren = {
  ToolsSlugRoute: ToolsSlugRoute,ToolsIndexRoute: ToolsIndexRoute
}

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren)




const UseCasesRouteChildren = {
  UseCasesSlugRoute: UseCasesSlugRoute,UseCasesIndexRoute: UseCasesIndexRoute
}

const UseCasesRouteWithChildren = UseCasesRoute._addFileChildren(UseCasesRouteChildren)




const IndexAZRouteChildren = {
  IndexAZLetterRoute: IndexAZLetterRoute,IndexAZIndexRoute: IndexAZIndexRoute
}

const IndexAZRouteWithChildren = IndexAZRoute._addFileChildren(IndexAZRouteChildren)




const IndexCodepointsRouteChildren = {
  IndexCodepointsRangeRoute: IndexCodepointsRangeRoute,IndexCodepointsIndexRoute: IndexCodepointsIndexRoute
}

const IndexCodepointsRouteWithChildren = IndexCodepointsRoute._addFileChildren(IndexCodepointsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CategoriesRoute: CategoriesRouteWithChildren,ContactRoute: ContactRoute,DecorativeRoute: DecorativeRouteWithChildren,DrawRoute: DrawRoute,ExportRoute: ExportRoute,KaomojiRoute: KaomojiRouteWithChildren,LennyFacesRoute: LennyFacesRoute,MySymbolsRoute: MySymbolsRoute,PackRoute: PackRouteWithChildren,PrivacyRoute: PrivacyRoute,ScriptsRoute: ScriptsRouteWithChildren,TermsRoute: TermsRoute,ToolsRoute: ToolsRouteWithChildren,UseCasesRoute: UseCasesRouteWithChildren,CollectionsSlugRoute: CollectionsSlugRoute,FontGeneratorSlugRoute: FontGeneratorSlugRoute,FontsSlugRoute: FontsSlugRoute,IndexAZRoute: IndexAZRouteWithChildren,IndexCodepointsRoute: IndexCodepointsRouteWithChildren,SymbolSlugRoute: SymbolSlugRoute,FontGeneratorIndexRoute: FontGeneratorIndexRoute,FontsIndexRoute: FontsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)